<div class="p-grid" style="margin: 30px;">
  <!-- -   GRAPHE  SECTION 0 -->
  <div class="p-col-12 p-lg-12 p-xl-12">
    <p-panel header="Nombre de stock PTL en cours" class="qos-retour">
      <p-chart [data]="barData" [height]="'310'" type="bar" [options]="nbTraiteesOptions"></p-chart>
      <p-footer>
        <h4>Nombre total : {{nbTotal}}</h4>
      </p-footer>
    </p-panel>
  </div>
  <!--     GRAPHE  SECTION 1 -->
  <div class="p-col-12 p-lg-6 p-xl-6">
    <p-panel header="Volume de fiches à traiter par tranche horaire J-J" class="qos-retour">
      <p-chart [data]="donneeGrapheFicheTrancheJ" type="bar" [options]="delaiOptions"></p-chart>
    </p-panel>
  </div>
  <div class="p-col-12 p-lg-6 p-xl-6">
    <p-panel header="Volume de fiches à traiter par tranche horaire J+1" class="qos-retour">
      <p-chart [data]="donneeGrapheFicheTrancheJPlus1" type="bar" [options]="delaiOptions"></p-chart>
    </p-panel>
  </div>
  <!--     GRAPHE  SECTION 2 -->
  <div class="p-col-12">
    <p-panel header="Volume de fiches validées par tranche horaire J-J" class="qos-retour">
      <p-chart [data]="donneeGrapheFicheTraiteJ" type="bar" [options]="delaiOptions"></p-chart>
    </p-panel>
  </div>
<!--  <div class="p-col-12">
    <p-panel header="VOLUME DE FICHES RESTANTES A TRAITER PAR TRANCHE HORAIRE" class="qos-retour">
      <p-chart [data]="grapheDelai" type="bar" [options]="delaiOptions"></p-chart>
    </p-panel>
  </div>-->
  <div class="p-col-12 p-lg-6 p-xl-6" >
    <div class="p-grid">
      <p-panel class="p-col-12 p-lg-12" styleClass="qos-retour">
        <p-header>Volumétrie des fiches reçues moyenne hebdo </p-header>
        <p-chart type="bar" [data]="donneeGrapheFicheRecueHebdo" [options]="optionsGrapheFicheRecueHebdo"></p-chart>
      </p-panel>
    </div>
  </div>
  <div class="p-col-12 p-lg-6 p-xl-6" >
      <div class="p-grid">
        <p-panel class="p-col-12 p-lg-12" styleClass="qos-retour">
          <p-header>Volumétrie des fiches reçues S-1</p-header>
          <p-chart type="bar" [data]="donneeGrapheFicheRecue" [options]="optionsGrapheFicheRecue"></p-chart>
        </p-panel>
      </div>
  </div>
  <!--      TABLEAU EN TEMPS REEL  -->
  <div class="p-col-12">
    <div class="p-grid">
      <p-panel class="p-col-12" styleClass="qos-retour">
        <p-header>Suivi performance globale en temps réel</p-header>
        <div class="p-col-12">
          <div style="margin: 10px auto;">
            <p-card style="color: #8A5340; text-align: center">
              {{dateAujourdhui}} - fiches reçues : {{nombreFicheRecuesTotal}}
            </p-card>
          </div>
          <div class="p-col-12">
            <button pButton label="Filtrer" (click)="showListePersonne()" ></button>
          </div>
          <p-table #recus [rowHover]="true" styleClass="ui-table-customers" [columns]="recuCols" [value]="recuLists" [paginator]="false" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="">
            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of recuCols" [pSortableColumn]="col.field">
                  {{col.header}}
                  <!--p-sortIcon [field]="col.field" ></p-sortIcon-->
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-moderation let-columns="columns">
              <tr>
                <td *ngFor="let col of columns">
                  <ng-template [ngIf]="col.field !== 'id_complexite'">
                          <span >
                            {{moderation[col.field]}}
                          </span>
                    </ng-template>
                  </td>
                </tr>
              </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5" style="text-align:center; height: 50px;" >Pas de donnée à afficher.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-panel>
    </div>
  </div>
  <!--      TABLEAU SUIVI GLOBAL MENSUELS  -->
  <div class="p-col-12">
    <div class="p-grid">
      <p-panel class="p-col-12" styleClass="qos-retour">
        <p-header>Suivi mensuel de la performance globale</p-header>
        <div class="p-col-12">
          <div>
            <p-card style="color: #8A5340; text-align: center">
              {{moisEC}} - fiches reçues : {{nombreFicheRecuesTotalMensuel}}
            </p-card>
          </div>
          <p-table #globalMensuel [rowHover]="true" styleClass="ui-table-customers" [columns]="globalMensuelCols" [value]="globalMensuelLists" [paginator]="false" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="">
            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of globalMensuelCols" [pSortableColumn]="col.field">
                  {{col.header}}
                  <!--p-sortIcon [field]="col.field" ></p-sortIcon-->
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-moderation let-columns="columns">
              <tr>
                <td *ngFor="let col of columns">
                  <ng-template [ngIf]="col.field !== 'id_complexite'">
                          <span >
                            {{moderation[col.field]}}
                          </span>
                  </ng-template>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5" style="text-align:center; height: 50px;" >Pas de donnée à afficher.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-panel>
    </div>
  </div>
  <!-- VOLUMETRIE FICHES TRAITEES -->
  <app-volumetrie-traitees class="p-col-12"></app-volumetrie-traitees>
  <!-- FIN VOLUMETRIE FICHES TRAITEES -->



  <!-- QUALITE ISO HEBDO -->


  <div class="p-col-12">
    <p-panel header="Suivi qualité iso hebdomadaire" class="qos-init" [toggler]="'header'" [toggleable]="true" [expandIcon]="'pi pi-angle-down'" [collapseIcon]="'pi pi-angle-up'">
      <div class="p-grid">
        <p-chart [data]="tauxIsoHebdoGrapheData" type="line" class="p-col-12" [height]="'340'" [options]="optionsGrapheTauxIso"></p-chart>
        <p-panel [collapsed]="collapsedIso" header="Tableau suivi qualité iso hebdomadaire" class="table-iso" [toggler]="'header'" [toggleable]="true"  [expandIcon]="'pi pi-angle-down'" [collapseIcon]="'pi pi-angle-up'">
          <p-table #validees [rowHover]="true" [rowsPerPageOptions]="[10,25,50]" styleClass="ui-table-customers" [columns]="tauxISoHebdoCols" [value]="tauxIsoHebdoListe" class="p-col-12">
            <ng-template pTemplate="caption" style="text-align:center;font-weight: bold;">
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of tauxISoHebdoCols" [pSortableColumn]="col.field">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" ></p-sortIcon>
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-values let-columns="columns">
              <tr>
                <td *ngFor="let col of columns">
                    <span >
                      {{values[col.field]}}
                    </span>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td  style="text-align:center; height: 50px;background-color: #f9f7f5;" >Pas de donnée à afficher.</td>
              </tr>
            </ng-template>
          </p-table>
        </p-panel>
      </div>
   </p-panel>
  </div>



  <!-- QUALITE ISO MENSUEL -->
    <div class="p-col-12">
     <p-panel header="Suivi qualité iso mensuel" class="qos-init" [toggler]="'header'" [toggleable]="true" [expandIcon]="'pi pi-angle-down'" [collapseIcon]="'pi pi-angle-up'">
        <div class="p-grid">
          <p-chart [data]="tauxIsoMensuelGrapheData" type="line" class="p-col-12" [height]="'340'" [options]="optionsGrapheTauxIso"></p-chart>
          <p-panel [collapsed]="collapsedIso" header="Tableau suivi qualité iso hebdomadaire" class="table-iso" [toggler]="'header'" [toggleable]="true"  [expandIcon]="'pi pi-angle-down'" [collapseIcon]="'pi pi-angle-up'">
            <p-table #validees [rowHover]="true" [rowsPerPageOptions]="[10,25,50]" styleClass="ui-table-customers" [columns]="tauxISoCols" [value]="tauxIsoMensuelListe" class="p-col-12">
              <ng-template pTemplate="caption" style="text-align:center;font-weight: bold;">
              </ng-template>

              <ng-template pTemplate="header">
                <tr>
                  <th *ngFor="let col of tauxISoCols" [pSortableColumn]="col.field">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" ></p-sortIcon>
                  </th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-values let-columns="columns">
                <tr>
                  <td *ngFor="let col of columns">
                      <span >
                        {{values[col.field]}}
                      </span>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td  style="text-align:center; height: 50px;background-color: #f9f7f5;" >Pas de donnée à afficher.</td>
                </tr>
              </ng-template>
            </p-table>
          </p-panel>
        </div>
     </p-panel>
    </div>
  <!-- FIN QUALITE ISO MENSUEL -->
</div>


